import { useQuery } from 'react-query';
import { TorneoType, UserType } from '../types/types';
import hash from 'object-hash';

const baseRoute = process.env.REACT_APP_BASE_URL;

export type PostTorneoParams = { torneo?: TorneoType };

async function getTorneosApiCall(logedUser?: UserType | null) {
  if (!logedUser?.token) return null;
  const headers = {
    'Authorization': `Bearer ${logedUser.token}`,
  };
  const response = await fetch(
    `${baseRoute}/api/torneos`,
    { headers,  method: 'GET' },
  );
  if (!response.ok) {
    throw new Error('Problem fetching data');
  }
  const resp = await response.json();
  return resp as TorneoType[];
}

async function addOrEditTorneoApiCall(params?: PostTorneoParams, logedUser?: UserType | null) {
  if (!logedUser?.token) return null;

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${logedUser.token}`,
  };
  const response = await fetch(
    `${baseRoute}/api/torneos`,
    { headers, body: JSON.stringify(params), method: 'POST' },
  );
  if (!response.ok) {
    throw new Error('Problem fetching data');
  }
  const resp = await response.json();
  return resp as TorneoType;
}

async function deleteTorneoApiCall(id?: string | null, logedUser?: UserType | null) {
  if (!logedUser?.token) return null;
  if (!id) return null;
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${logedUser.token}`,
  };
  const response = await fetch(
    `${baseRoute}/api/torneos`,
    { headers, body: JSON.stringify({ id }), method: 'DELETE' },
  );
  if (!response.ok) {
    throw new Error('Problem fetching data');
  }
  const resp = await response.json();
  return resp as boolean;
}

export function useGetTorneos(logedUser?: UserType | null) {
  return useQuery<TorneoType[] | null, Error>(
    ['getTorneos', hash(logedUser ?? '')],
    () => getTorneosApiCall(logedUser), {
      cacheTime: 3600,
      refetchOnWindowFocus: false,
    },
  );
}

export function useAddOrUpdateTorneo(params?:PostTorneoParams, logedUser?: UserType | null) {
  return useQuery<TorneoType | null, Error>(
    ['addTorneo', hash(params || ''), hash(logedUser ?? '')],
    () => addOrEditTorneoApiCall(params, logedUser), {
      cacheTime: 3600,
      refetchOnWindowFocus: false,
      enabled: false,
      retry: false,
    },
  );
}

export function useAutoAddOrUpdateTorneo(params?:PostTorneoParams, logedUser?: UserType | null) {
  return useQuery<TorneoType | null, Error>(
    ['addTorneo', hash(params || ''), hash(logedUser ?? '')],
    () => addOrEditTorneoApiCall(params, logedUser), {
      cacheTime: 3600,
      refetchOnWindowFocus: false,
    },
  );
}

export function useDeleteTorneo(id: string | null, logedUser?: UserType | null) {
  return useQuery<boolean | null, Error>(
    ['deleteTorneo', id, hash(logedUser ?? '')],
    () => deleteTorneoApiCall(id, logedUser), {
      cacheTime: 3600,
      refetchOnWindowFocus: false,
    },
  );
}